import styled from 'styled-components';

const Main = styled.main`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 5px;
`;

export default Main;
